import { FeedbackQuestionScopeEnum, FeedbackQuestionTypeEnum } from '@/types/schema';

import { useFeedbackQuestionsQuery } from '../../graphql/queries/generated/feedbackQuestions';

const useAIFeedbackData = () => {
  const [{ fetching, data }] = useFeedbackQuestionsQuery({
    variables: {
      filters: {
        scope: FeedbackQuestionScopeEnum.Global,
        types: [FeedbackQuestionTypeEnum.GenerativeTaskQuality],
      },
    },
  });
  const feedbackQuestions = data?.feedbackQuestions;

  return { fetching, feedbackQuestions };
};

export default useAIFeedbackData;
